// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"9d9a52c2","734":"3e976985","816":"b2f56279","873":"1d14f16f","877":"e4634061","892":"7cd99ae3"}[chunkId] + ".chunk.js";
};